export const ERRORS = {
  couldNotComment: 'There was a problem saving your comment. Please try again.',
  couldNotCloseIssue: 'Could not close issue',
  couldNotReopenIssue: 'Could not reopen issue',
  couldNotDeleteComment: 'Could not delete this comment',
  couldNotEditComment: 'Could not edit issue comment',
  couldNotEditCommentStale: 'The content you are editing has changed. Please copy your edits and refresh the page.',
  couldNotReact: 'Could not add reaction. Please try again.',
  couldNotSubscribe: 'Could not subscribe. Please try again.',
  couldNotUnsubscribe: 'Could not unsubscribe. Please try again.',
}
